var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfluenceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1758 56.304C11.5552 57.3572 10.8583 58.5792 10.2664 59.5529C9.73662 60.4847 10.021 61.6863 10.9061 62.2554L23.3169 70.2038C23.7526 70.4837 24.278 70.5698 24.7752 70.4428C25.2725 70.3158 25.6998 69.9862 25.9614 69.5282C26.4578 68.6638 27.0975 67.5411 27.7944 66.3389C32.711 57.8937 37.6563 58.927 46.573 63.3582L58.8788 69.4487C59.3449 69.6796 59.8809 69.7042 60.3648 69.517C60.8486 69.3298 61.239 68.9468 61.4469 68.4551L67.3564 54.5454C67.7739 53.552 67.3491 52.3936 66.4017 51.9423C63.805 50.6706 58.6402 48.137 53.9909 45.8022C37.2648 37.347 23.0496 37.8935 12.1758 56.304Z",
    fill: "url(#paint0_linear_442_4768)",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8242 24.7388C68.4448 23.6856 69.1417 22.4635 69.7336 21.4899C70.2634 20.5581 69.979 19.3564 69.094 18.7874L56.6831 10.839C56.2439 10.5311 55.7016 10.4269 55.1857 10.5512C54.6698 10.6756 54.2267 11.0173 53.9622 11.4947C53.4658 12.3591 52.8262 13.4818 52.1293 14.684C47.2126 23.1292 42.2674 22.0959 33.3507 17.6647L21.083 11.604C20.6169 11.3732 20.0809 11.3485 19.5971 11.5357C19.1133 11.7229 18.7229 12.1059 18.5149 12.5976L12.6054 26.5073C12.1879 27.5007 12.6127 28.6591 13.5601 29.1104C16.1568 30.3821 21.3217 32.9157 25.971 35.2505C42.7352 43.6957 56.9504 43.1294 67.8242 24.7388Z",
    fill: "url(#paint1_linear_442_4768)",
    stroke: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_442_4768",
    x1: 67.0223,
    y1: 74.3072,
    x2: 52.1664,
    y2: 41.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_442_4768",
    x1: 12.9777,
    y1: 6.72568,
    x2: 27.8569,
    y2: 39.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfluenceLight);
export default __webpack_public_path__ + "static/media/confluence-light.7af60800b04ee48201e8c7065a2c8823.svg";
export { ForwardRef as ReactComponent };